<dynamic-form [fields]="regItensQuizz"></dynamic-form>
<div class="footer" [hidden]="etapaAtual > qtdEtapas">
  <div>
    <img
      src="assets/images/others/botao_anterior.png"
      (click)="etapaAnterior()"
      [ngClass]="{ 'lovers--disabled': etapaAtual === 1 }"
    />
  </div>
  <div>
    <div
      *ngFor="let etapa of etapas"
      class="etapa"
      [ngClass]="{ 'etapa--selecionada': etapa === etapaAtual }"
      (click)="irParaEtapa(etapa)"
    ></div>
  </div>
  <div>
    <img
      src="assets/images/others/botao_proxima.png"
      (click)="proximaEtapa()"
      [hidden]="qtdEtapas === etapaAtual"
      [ngClass]="{ 'lovers--disabled': qtdEtapas === etapaAtual }"
    />
    <img
      src="assets/images/others/botao_finalizar.png"
      *ngIf="qtdEtapas === etapaAtual"
      (click)="enviarQuizz()"
    />
  </div>
</div>
